// This file was auto-generated by Fern from our API Definition.
export const QueryApplicationVariantsRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
